import axios from 'axios';
import config from '../../utils/config';
import { getItem } from '../../utils/utils';

const { API_URL } = config;

export const apiHeaders = async () => {
  const token = await getItem('token');
  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
  }
  return {
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  };
};
//for cros-origin error header
// export const addCardHeader = async () => {
//   return {
//     headers: {
//       Accept: '*/*',
//       'Content-Type': 'application/x-www-form-urlencoded',
//     },
//   };
// };

export const getFetchApi = async (endpoint) => {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'GET',
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  });
  return response.json();
};

export const postFetchApi = async (endpoint, apiData) => {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
    body: apiData,
  });
  return response;
};

export const putFetchApi = async (endpoint, apiData) => {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'PUT',
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
    body: apiData,
  });
  return response.json();
};

export const patchFetchApi = async (endpoint, apiData) => {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'PATCH',
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
    body: apiData,
  });
  return response.json();
};

export const deleteFetchApi = async (url) => {
  const response = await fetch(`${url}`, {
    method: 'DELETE',
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  });
  return response.json();
};

export const getApi = async (url) => axios.get(`${API_URL}${url}`, await apiHeaders());

export const postApi = async (url, apiData) => axios.post(`${API_URL}${url}`, apiData, await apiHeaders());

export const putApi = async (url, apiData) => axios.put(`${API_URL}${url}`, apiData, await apiHeaders());

export const patchApi = async (url, apiData) => axios.patch(`${API_URL}${url}`, apiData, await apiHeaders());

export const deleteApi = async (url) => axios.delete(`${API_URL}${url}`, await apiHeaders());

export const getApiError = (error) => (typeof error?.response?.data?.error === 'string' ? error.response.data.error : 'Something went Wrong');

//make code uncomment if to make logic work for unauthorize api call

// export const setupInterceptors = (callback) => {
//   axios.interceptors.response.use(
//     (response) => response,
//     (error) => {
//       if ([401].includes(error?.response?.status)) {
//         clearItem();
//         callback();
//       }

//       return Promise.reject(error);
//     }
//   );
// };

// setupInterceptors(() => {
//   window.location.reload();
// });
